import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-ticket-icon',
  templateUrl: './shopping-ticket.component.html'
})
export class ShoppingTicketComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
